import React from 'react';
import PropTypes from 'prop-types';
import { MosaicWall, TextMosaic, TextMosaicDto } from '@ami/react/core';
import { makeConcealable } from '@ami/react/core';
import _ from 'lodash';
import { Industry } from '../../industries/industry';
import industriesService from '../../industries/industriesService';
import { IndustryFilter } from '../../industries/industryFilter';

class CreateQuoteIndustries extends React.PureComponent {
  static propTypes = {
    industryId: PropTypes.string,
    carrierId: PropTypes.string.isRequired,
    weightCategoryId: PropTypes.string.isRequired,
    onUpdate: PropTypes.func.isRequired,
    industries: PropTypes.arrayOf(PropTypes.instanceOf(Industry)).isRequired,
    title: PropTypes.string,
  };

  state = {
    industries: [],
  };

  async componentDidMount() {
    const { carrierId, weightCategoryId } = this.props;
    this.setState({
      industries: await industriesService.search(
        new IndustryFilter({ carrierId, weightCategoryId })
      ),
    });
  }

  async componentDidUpdate(prevProps) {
    const { carrierId, weightCategoryId } = this.props;
    if (
      prevProps.carrierId !== carrierId ||
      prevProps.weightCategoryId !== weightCategoryId
    ) {
      this.setState({
        industries: await industriesService.search(
          new IndustryFilter({ carrierId, weightCategoryId })
        ),
      });
    }
  }

  sort = (items) => _.sortBy(items, (x) => x.name);

  mapToMosaicDto(selectedIndustryId, industries) {
    return industries.map(
      (x) =>
        new TextMosaicDto({
          id: x.id,
          label: x.name,
          selected: x.id === selectedIndustryId,
        })
    );
  }

  getIndustries() {
    const { industryId } = this.props;
    const { industries } = this.state;

    var i = this.sort(industries);
    var a = this.mapToMosaicDto(industryId, i);
    return a;
  }

  render() {
    const { title, industryId } = this.props;
    const { industries } = this.state;
    const invalid = industryId === undefined;

    return (
      <React.Fragment>
        <MosaicWall
          placeholder="Please select an industry"
          childrenContainerClassName={`row justify-content-center ${
            invalid && 'invalid'
          }`}
          title={title}
        >
          {this.getIndustries().map((x) => (
            <TextMosaic
              widthColumns={4}
              key={x.id}
              data={x}
              onClick={(industryId) =>
                this.props.onUpdate({
                  industryId,
                  industryName: industries.find((x) => x.id === industryId)
                    .name,
                })
              }
            />
          ))}
          <TextMosaic
            widthColumns={4}
            data={
              new TextMosaicDto({
                label: <div>Not Specified</div>,
                selected: industryId === null,
              })
            }
            onClick={() =>
              this.props.onUpdate({
                industryId: null,
                industryName: 'Not Specified',
              })
            }
          />
        </MosaicWall>
      </React.Fragment>
    );
  }
}

export default makeConcealable(CreateQuoteIndustries);
